import { useState, useCallback } from 'react';
import { FacilityEquipmentAccordionList } from '../../components/EquipmentList/FacilityEquipmentAccordionList';

interface ViewFacilityEquipmentProps {
  facilityId: string;
}

export const ViewFacilityEquipment = ({
  facilityId,
}: ViewFacilityEquipmentProps) => {
  const [equipmentCount, setEquipmentCount] = useState<number | null>(null);

  const handleCountResolved = useCallback((count: number) => {
    setEquipmentCount(count);
  }, []);

  return (
    <div className="flex flex-col gap-4 border border-[#DCDDE0] rounded-[12px] p-4 flex-1">
      <p
        className="text-[#474A4C] font-medium"
        style={{ fontSize: '18px', lineHeight: '28px' }}
      >
        Aparatura {equipmentCount !== null ? `(${equipmentCount})` : ''}
      </p>
      <div className="flex-1 flex flex-col">
        <FacilityEquipmentAccordionList
          facilityId={facilityId}
          onCountResolved={handleCountResolved}
        />
      </div>
    </div>
  );
};
